import { BasePerimeter } from '@argon/iam/perimeters'
import { ROLES } from '@argon/iam/utils'

export default new BasePerimeter({
  purpose: 'policy',
  can: {
    read(policy) {
      return this.hasAction(policy, 'read')
    },
    update(policy) {
      return this.hasAction(policy, 'update')
    },
    destroy(policy) {
      return this.hasAction(policy, 'delete')
    },
    manage() {
      return this.hasPermission('policy:manage')
    },
    list() {
      return this.hasPermission('policy:read')
    },
    create() {
      return this.hasPermission('policy:create')
    },
    administrate() {
      return this.isAdmin()
    },
    atLeastAdvisor() {
      let org = this.child.getters['organizations/activeOrg']
      return this.isLevelOrAbove(org, ROLES.MEMBER)
    },
    atLeastManager() {
      let org = this.child.getters['organizations/activeOrg']
      return this.isLevelOrAbove(org, ROLES.MANAGER)
    }
  }
})
